import * as React from "react";
import { cn } from "@/lib/utils";

/**
 * 通用骨架屏占位块。配合 `animate-pulse` 给出柔和的"正在加载"信号。
 *
 * 用法:
 *   <Skeleton className="h-4 w-32" />        // 一行文字
 *   <Skeleton className="h-32 w-full" />     // 卡片块
 */
export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-muted/70", className)}
      {...props}
    />
  );
}

/** 列表行骨架（标题 + 副信息） */
export function SkeletonListItem() {
  return (
    <div className="px-4 py-3.5 flex items-start gap-4 border-b last:border-b-0">
      <div className="flex-1 min-w-0 space-y-2">
        <Skeleton className="h-4 w-[70%]" />
        <div className="flex gap-2">
          <Skeleton className="h-3 w-16" />
          <Skeleton className="h-3 w-12" />
          <Skeleton className="h-3 w-20" />
        </div>
      </div>
      <Skeleton className="h-3 w-16 shrink-0" />
    </div>
  );
}

/** 列表骨架（默认 5 行） */
export function SkeletonList({ rows = 5 }: { rows?: number }) {
  return (
    <div className="rounded-md border bg-card">
      {Array.from({ length: rows }, (_, i) => <SkeletonListItem key={i} />)}
    </div>
  );
}

/** 卡片网格骨架 */
export function SkeletonCardGrid({ count = 6 }: { count?: number }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {Array.from({ length: count }, (_, i) => (
        <div key={i} className="rounded-lg border bg-card p-4 space-y-3">
          <Skeleton className="h-4 w-2/3" />
          <Skeleton className="h-3 w-full" />
          <Skeleton className="h-3 w-4/5" />
          <div className="flex gap-2 pt-1">
            <Skeleton className="h-3 w-12" />
            <Skeleton className="h-3 w-16" />
          </div>
        </div>
      ))}
    </div>
  );
}
